'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AwesomeLoader;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _loader = require('./loader-128.gif');

var _loader2 = _interopRequireDefault(_loader);

var _loader3 = require('./loader-256.gif');

var _loader4 = _interopRequireDefault(_loader3);

var _loader5 = require('./loader-512.gif');

var _loader6 = _interopRequireDefault(_loader5);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sizeMap = {
  1: _loader2.default,
  2: _loader4.default,
  3: _loader6.default
};

/**
 * Displays a super-awesome loading indicator.
 *
 * @param {Number} size
 * A value from 1 to 3 that determines what size the loader should be.
 */
function AwesomeLoader(_ref) {
  var size = _ref.size,
      withMargin = _ref.withMargin,
      noContainer = _ref.noContainer;

  var img = _react2.default.createElement('img', { src: sizeMap[size], alt: 'Loading...' });
  return noContainer ? img : _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('AwesomeLoader', withMargin && 'AwesomeLoader--with-margin') },
    img
  );
}

AwesomeLoader.propTypes = {
  // Size from 1 to 3.
  size: _propTypes2.default.number,
  // Should we add some margin?
  withMargin: _propTypes2.default.bool,
  // Don't render in a container, just give us the image
  noContainer: _propTypes2.default.bool
};

AwesomeLoader.defaultProps = {
  size: 1,
  withMargin: true,
  noContainer: false
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/AwesomeLoader/index.js
// module id = 612
// module chunks = 0